import { getStorage } from './storage'

export const premium = 'premium'
export const standard = 'standard'

export const useSubscription = () => {
  return getStorage('subscription') === premium
}
